import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6eda04a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bind-amazon" }
const _hoisted_2 = { class: "search flex-ter" }
const _hoisted_3 = { style: {"text-align":"left"} }
const _hoisted_4 = { class: "footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { reactive, ref, nextTick, computed, toRaw } from 'vue'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { amazonGet, bindAmazonSku } from '@/apis/inShipping'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: ['rowItem'],
  emits: ['update:visible', 'success', 'getInfo'],
  setup(__props, { emit: emits }) {

const props = __props



const form = reactive({
  amazonMsku: ''
})
const checkSku = ref('')
const store = useStore()
const filterData = computed(() => {
  return {
    amazonMsku: form.amazonMsku,
    customerShopId: store.getters.curShop,
    pageSize: 500,
    pageNum: 1
  }
})
const tableData: any = ref([])
const searchLoading = ref(false)
const search = () => {
  if (!form.amazonMsku) return ElMessage.warning(t('请搜索需要绑定的Amazon sku'))
  searchLoading.value = true
  amazonGet({
    amazonMsku: form.amazonMsku,
    customerShopId: store.getters.curShop
  }).then((res: any) => {
    if (res.success) {
      if (res.data && res.data.length > 0) {
        tableData.value = res.data
      } else {
        ElMessage.warning(t('请输入正确的Amazon sku'))
      }
    }
  }).finally(() => { searchLoading.value = false })
}
const STableRef = ref()

let selectionList: any[]
const columns: any = [
  // {
  //   label: t('图片'),
  //   prop: 'mainImg',
  //   slotName: 'mainImg'
  // },
  {
    label: t('商品信息'),
    prop: 'productSkuInfo',
    align: 'center',
    slotName: 'productSkuInfo'
  }
]

const submit = () => {
  if (!tableData.value.length) return ElMessage.warning(t('请搜索需要绑定的Amazon sku'))
  bindAmazonSku({
    amazonMsku: checkSku.value,
    shopProductSkuId: props.rowItem.shopProductSkuId
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('Amazon sku绑定成功'))
      emits('success')
      emits('getInfo', tableData.value.filter((v: any) => { return v.amazonMsku === checkSku.value })[0], props.rowItem)
      emits('update:visible', false)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_unref(t)('Amazon sku')) + ": ", 1),
        _createVNode(_component_el_input, {
          style: {"width":"200px","margin":"0 20px"},
          modelValue: _unref(form).amazonMsku,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).amazonMsku) = $event)),
          placeholder: _unref(t)('请输入Amazon sku')
        }, null, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: search
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(STable, {
        ref: (_value, _refs) => {
          _refs['STableRef'] = _value
          STableRef.value = _value
        },
        "table-data": tableData.value,
        columns: columns,
        showPagination: false,
        "max-height": "480"
      }, {
        mainImg: _withCtx(({row}) => [
          (row.mainImg)
            ? (_openBlock(), _createBlock(ShoppingPreview, {
                key: 0,
                image: row.mainImg
              }, null, 8, ["image"]))
            : _createCommentVNode("", true)
        ]),
        productSkuInfo: _withCtx(({row}) => [
          _createVNode(_component_el_radio, {
            label: row.amazonMsku,
            size: "large",
            modelValue: checkSku.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checkSku).value = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", null, _toDisplayString(_unref(t)('Amazon sku')) + ": " + _toDisplayString(row?.amazonMsku ?? '') + " (" + _toDisplayString(row.sellStatus === 1 ? _unref(t)('可售') : _unref(t)('不可售')) + ")", 1),
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(row.productName ?? '') + "/", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.productProp || '').split(';'), (prop) => {
                    return (_openBlock(), _createElementBlock("span", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                  }), 128))
                ])
              ])
            ]),
            _: 2
          }, 1032, ["label", "modelValue"])
        ]),
        _: 1
      }, 8, ["table-data"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('update:visible', false)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: submit,
        disabled: !checkSku.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 64))
}
}

})